export default __webpack_public_path__ + "static/media/lampBottom.e762b991.gif";